module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-8.3a112793.mp3";